import { reactions } from "@/mocks/guaData";

export default function Reactions() {
  return (
    <section id="reactions" className="bg-background-50 py-14 md:py-20">
      <div className="container-page">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <h2 className="heading-font text-2xl text-foreground-950 md:text-3xl">
              🎬 网友真实反应合集
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              从路人到第一线，围观名场面，看全网网友如何一秒入戏。
            </p>
          </div>
          <a
            href="#contact"
            className="hidden items-center gap-1 text-sm font-bold text-primary-600 hover:text-primary-700 sm:flex"
          >
            投稿你的反应
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {reactions.map((r) => (
            <article
              key={r.id}
              className="group animate-pop cursor-pointer overflow-hidden rounded-2xl bg-background-100"
            >
              <div className="relative overflow-hidden">
                <img
                  src={r.img}
                  alt={`网友反应视频：${r.title}`}
                  className="h-56 w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-full bg-background-50/90 px-2.5 py-0.5 text-xs font-bold text-foreground-800">
                  {r.source}
                </span>
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/90 text-background-50 backdrop-blur transition-transform group-hover:scale-110">
                    <i className="ri-play-fill pl-0.5 text-xl"></i>
                  </span>
                </span>
              </div>
              <div className="p-4">
                <h3 className="line-clamp-2 min-h-[44px] text-sm font-bold leading-6 text-foreground-900">
                  {r.title}
                </h3>
                <p className="mt-2 flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-chat-3-line text-primary-500"></i>
                  {r.comments}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}